<div class="w-full flex flex-col pt-5 gap-md">
  <div class="flex justify-between items-center">
    <div class="flex items-center gap-lg">
      <span class="text-4xl font-bold">
        {{ "MasterData.Sidebar.Catalog" | i18nextEager }}
      </span>
      @if (divisions.value()?.data; as divs) {
        @if (divs.length > 1) {
          <doka-select
            class="w-48"
            [value]="effectiveDivisionId()"
            (valueChange)="onDivisionChange($any($event))"
            data-testid="catalog-division-select"
          >
            @for (division of divs; track division.id) {
              <doka-select-option [value]="division.id" [label]="division.name"></doka-select-option>
            }
          </doka-select>
        }
      }
    </div>
    <div>
      <doka-button-group data-testid="catalog-create-buttons">
        <doka-button-group-button (click)="createNewCatalogItem()">
          <ng-template #icon> add </ng-template>
          <ng-template #text> {{ "MasterData.NewCatalogItemModal.ButtonTitle" | i18nextEager }} </ng-template>
        </doka-button-group-button>
        <doka-button-group-button (click)="createNewCatalogCategory()">
          <ng-template #icon> add </ng-template>
          <ng-template #text> {{ "MasterData.NewCatalogCategoryModal.ButtonTitle" | i18nextEager }} </ng-template>
        </doka-button-group-button>
      </doka-button-group>
    </div>
  </div>
  <doka-search-field
    (valueChange)="searchText.set($event)"
    [placeholder]="'Common.Search' | i18nextEager"
    data-testid="catalog-search-field"
  />
  @if (catalogCategories.isLoading() || catalogItems.isLoading()) {
    <app-spinner />
  } @else {
    <doka-table data-testid="catalog-grid">
      <doka-thead>
        <doka-tr>
          <doka-th>
            {{ "MasterData.CatalogGrid.Code" | i18nextEager }}
          </doka-th>
          <doka-th>
            {{ "MasterData.CatalogGrid.Name" | i18nextEager }}
          </doka-th>
          <doka-th />
        </doka-tr>
      </doka-thead>
      <doka-tbody>
        @for (item of detailedCatalogCategories(); track item.id) {
          <doka-tr [expanded]="item.isExpanded" (selectedChange)="item.isExpanded = !item.isExpanded">
            <doka-td>
              <span [attr.data-testid]="'catalog-category-code-' + item.id">{{ item.code }}</span>
            </doka-td>
            <doka-td>
              <span [attr.data-testid]="'catalog-category-name-' + item.id">{{ item.name }}</span>
            </doka-td>

            <doka-td>
              <div class="flex justify-end">
                <doka-action-menu [attr.data-testid]="'catalog-category-actions-' + item.id">
                  <doka-action-menu-item
                    icon="edit"
                    [text]="'Common.Edit' | i18nextEager"
                    (clicked)="editCatalogCategory(item)"
                  />
                </doka-action-menu>
                <a
                  class="action-icon"
                  [title]="'Overview.Grid.Expand' | i18nextEager"
                  role="button"
                  [attr.data-testid]="'catalog-category-toggle-' + item.id"
                >
                  <doka-icon [name]="item.isExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'" />
                </a>
              </div>
            </doka-td>

            <doka-details-tr>
              <doka-details-td>
                <doka-details-table>
                  <doka-details-thead>
                    <doka-details-tr>
                      <doka-details-th>
                        {{ "MasterData.CatalogDetailsGrid.Name" | i18nextEager }}
                      </doka-details-th>
                      <doka-details-th>
                        {{ "MasterData.CatalogDetailsGrid.InvNumber" | i18nextEager }}
                      </doka-details-th>
                      <doka-details-th>
                        {{ "MasterData.CatalogDetailsGrid.Templates" | i18nextEager }}
                      </doka-details-th>
                    </doka-details-tr>
                  </doka-details-thead>
                  <doka-details-tbody>
                    @for (subItem of item.items; track subItem.id) {
                      <doka-details-tr>
                        <doka-details-td>
                          <span [attr.data-testid]="'catalog-item-name-' + subItem.id">{{ subItem.name }}</span>
                        </doka-details-td>
                        <doka-details-td>
                          <span [attr.data-testid]="'catalog-item-inventory-number-' + subItem.id">{{
                            subItem.inventoryNumber
                          }}</span>
                        </doka-details-td>
                        <doka-details-td>
                          <span [attr.data-testid]="'catalog-item-templates-count-' + subItem.id">{{
                            subItem.templatesCount
                          }}</span>
                        </doka-details-td>
                        <doka-details-td>
                          <div class="flex justify-end">
                            <doka-action-menu [attr.data-testid]="'catalog-item-actions-' + subItem.id">
                              <doka-action-menu-item
                                icon="edit"
                                [text]="'Common.Edit' | i18nextEager"
                                (clicked)="editCatalogItem(subItem)"
                              />
                              <doka-action-menu-item
                                icon="edit"
                                [text]="'MasterData.CatalogDetailsGrid.EditTemplates' | i18nextEager"
                                (clicked)="navigateToTemplateDetails(subItem.id)"
                              />
                              <doka-action-menu-item
                                icon="delete"
                                [text]="'Common.Delete' | i18nextEager"
                                [alertStyle]="true"
                                (clicked)="confirmDeleteCatalogItem(subItem)"
                              />
                            </doka-action-menu>
                          </div>
                        </doka-details-td>
                      </doka-details-tr>
                    }
                  </doka-details-tbody>
                </doka-details-table>
              </doka-details-td>
            </doka-details-tr>
          </doka-tr>
        }
      </doka-tbody>
    </doka-table>
  }
</div>
